module.exports = {"helmetTitle":"Minha Veloe - Solicitar VeloeTag","identifiersTitle":"Solicitar VeloeTag","identifiersQuantity":"QUANTAS VELOETAGS VOCÊ QUER?","identifiersDescription":"Informe o número de VeloeTags que você deseja e o endereço de entrega.","addressDescription":"Em qual endereço você deseja receber seu pedido?","addressRadio":"Outro endereço da entrega","btnFollow":"Enviar aaa pedido","btnCancel":"Cancelar","titleModalError":"Tem algo errado com os dados informados. Tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/DashboardIdentifiersRequests/data.json
// module id = 2033
// module chunks = 0